import { forumThreads, rankList } from '@/mocks/routeData';

export default function ForumRank() {
  return (
    <section className="border-y border-stone-200/60 bg-white">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <div className="flex items-center gap-3">
              <span className="h-px w-10 bg-orange-400" />
              <span className="text-xs font-semibold uppercase tracking-[0.25em] text-orange-600">COMMUNITY · 社区热议</span>
            </div>
            <h2 className="font-mag mt-3 text-2xl font-black text-stone-900 md:text-4xl">
              顺序怎么排，这里吵得最有道理
            </h2>
          </div>
          <a href="#forum" className="flex shrink-0 cursor-pointer items-center gap-1 text-sm font-medium text-orange-600 whitespace-nowrap">
            进社区看看 <i className="ri-arrow-right-line" />
          </a>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-3">
          {/* 热议帖 */}
          <ul className="divide-y divide-stone-100 overflow-hidden rounded-2xl border border-stone-200/80 bg-white lg:col-span-2">
            {forumThreads.map((t) => (
              <li key={t.title}>
                <a
                  href="#forum"
                  className="flex cursor-pointer items-center gap-3 px-5 py-4 transition hover:bg-orange-50/50 md:px-6"
                >
                  <div className="min-w-0 flex-1">
                    <div className="flex flex-wrap items-center gap-2">
                      <span className={`rounded-md px-1.5 py-0.5 text-[11px] font-semibold ${t.boardClass}`}>{t.board}</span>
                      <h3 className="truncate text-sm font-bold text-stone-800 md:text-[15px]">{t.title}</h3>
                    </div>
                    <p className="mt-1 text-xs text-stone-400">by {t.by}</p>
                  </div>
                  <div className="flex shrink-0 flex-col items-end gap-1.5 text-xs text-stone-400">
                    <span className="flex items-center gap-1"><i className="ri-chat-3-line" /> {t.reply}</span>
                    <span className="flex items-center gap-1 text-orange-500"><i className="ri-heart-3-fill" /> {t.like}</span>
                  </div>
                </a>
              </li>
            ))}
          </ul>

          {/* 追更榜 */}
          <div className="flex flex-col rounded-2xl border border-stone-200/80 bg-gradient-to-b from-orange-50/60 to-white p-5 md:p-6">
            <div className="flex items-center justify-between">
              <p className="flex items-center gap-2 text-base font-bold text-stone-900" id="rank">
                <i className="ri-trophy-line text-orange-500" /> 本周追更榜
              </p>
              <span className="text-[11px] text-stone-400">热度实时</span>
            </div>
            <ol className="mt-4 flex flex-1 flex-col justify-between">
              {rankList.map((r) => (
                <li key={r.title} className="flex items-center gap-3 rounded-lg px-1 py-2.5 transition hover:bg-white">
                  <span
                    className={`font-mag w-6 shrink-0 text-center text-lg font-black ${
                      r.rank === 1 ? 'text-orange-500' : r.rank === 2 ? 'text-amber-500' : r.rank === 3 ? 'text-rose-400' : 'text-stone-300'
                    }`}
                  >
                    {r.rank}
                  </span>
                  <div className="min-w-0 flex-1">
                    <p className="truncate text-sm font-bold text-stone-800">{r.title}</p>
                    <p className="text-[11px] text-stone-400">热度 {r.heat}</p>
                  </div>
                  <span
                    className={`flex items-center gap-0.5 rounded-md px-1.5 py-0.5 text-[11px] font-semibold ${
                      r.tag === '高清线路' ? 'bg-rose-50 text-rose-600' : 'bg-teal-50 text-teal-600'
                    }`}
                  >
                    {r.tag}
                  </span>
                  <span
                    className={`flex w-9 shrink-0 items-center justify-center gap-0.5 text-[11px] font-semibold ${
                      r.move === 'up' ? 'text-rose-500' : r.move === 'down' ? 'text-teal-600' : 'text-stone-400'
                    }`}
                  >
                    <i className={r.move === 'up' ? 'ri-arrow-up-line' : r.move === 'down' ? 'ri-arrow-down-line' : 'ri-subtract-line'} />
                    {r.delta}
                  </span>
                </li>
              ))}
            </ol>
            <a href="#rank" className="mt-2 flex cursor-pointer items-center justify-center gap-1 rounded-xl bg-stone-900 py-2.5 text-sm font-medium text-white transition hover:bg-orange-600">
              查看完整榜单
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}